module.exports = __webpack_public_path__ + "img/slide3.ff6ec6d2.png";